function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useLayoutEffect, useState } from 'react';
import { placementArrow, placementPopup } from "../utils";
import useEvent from "../../../hooks/useEvent";

function useAlign(open, popupEle, target, placement) {
  var _useState = useState({
    ready: false,
    offsetX: 0,
    offsetY: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      offsetInfo = _useState2[0],
      setOffsetInfo = _useState2[1];

  var onAlign = useEvent(function () {
    if (!popupEle || !target || !open) return;
    var targetPos;
    var arrowPos;

    if (target instanceof HTMLElement) {
      targetPos = placementPopup(placement, target, popupEle);
      arrowPos = placementArrow(placement, popupEle);
    } else {
      targetPos = target;
    }

    setOffsetInfo(function (prev) {
      var _arrowPos, _arrowPos2;

      return _objectSpread(_objectSpread({}, prev), {}, {
        ready: true,
        offsetX: targetPos[0],
        offsetY: targetPos[1],
        arrowX: (_arrowPos = arrowPos) === null || _arrowPos === void 0 ? void 0 : _arrowPos[0],
        arrowY: (_arrowPos2 = arrowPos) === null || _arrowPos2 === void 0 ? void 0 : _arrowPos2[1]
      });
    });
  }); // Reset ready status when placement & open changed

  var resetReady = function resetReady() {
    setOffsetInfo(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        ready: false
      });
    });
  };

  useLayoutEffect(resetReady, [placement]);
  useLayoutEffect(function () {
    if (!open) {
      resetReady();
    }
  }, [open]);
  return [offsetInfo.ready, offsetInfo.offsetX, offsetInfo.offsetY, offsetInfo.arrowX, offsetInfo.arrowY, onAlign];
}

export default useAlign;